import React from "react"
import { Interval } from "luxon"
import { createAbsences } from "../../utils/createAbsences"
import ResourceCalendarAbsence from "../ResourceCalendarAbsence"

const AbsenceTimeLine = ({
  absences,
  calendarInterval,
  dayWidth,
  showDays,
}: {
  absences: any
  calendarInterval: Interval
  dayWidth: number
  showDays: boolean
}) => {
  const { absenceGroupedByOffsetMargin, absenceWeeks } = createAbsences(
    absences,
    calendarInterval,
    dayWidth
  )

  return (
    <div className="position-relative">
      {showDays &&
        absenceGroupedByOffsetMargin.map((absence, index) => (
          <ResourceCalendarAbsence
            key={index}
            width={dayWidth}
            offsetMargin={absence.offsetMargin}
            approved={absence.approved}
          />
        ))}
      {!showDays &&
        absenceWeeks.map((absenceWeek, index) => (
          <ResourceCalendarAbsence
            key={index}
            width={dayWidth * 7}
            offsetMargin={absenceWeek.offsetMargin}
            approved={absenceWeek.approved}
          />
        ))}
    </div>
  )
}

export default AbsenceTimeLine
